module.exports = __webpack_public_path__ + "static/media/kca.615c7b2f.jpg";